<template>
  <div>
    <OfficeBacklog
      v-if="!details"
      :lgSize="12"
      :lgOffset="0"
      :locParam="1"
      :idCity="0"
    ></OfficeBacklog>
    <OfficeShipped
      v-if="!details"
      :lgSize="12"
      :lgOffset="0"
      :locParam="1"
      :idCity="0"
    ></OfficeShipped>
  </div>

  <!--  <ActiveBacklog2 v-else :lgSize="12" :lgOffset="0" :locParam="1" :idCity="0" :details="1" @detailView="switchView" @modalLocation="modalLocation"></ActiveBacklog2>-->
</template>

<script>
import OfficeBacklog from "../../components/OfficeBacklog";
import OfficeShipped from "../../components/OfficeShipped";
import router from "../../router";
import { allowedPath } from "../../shared/utils";
// import ActiveBacklog2 from "../../components/ActiveBacklog-Stacked";
export default {
  name: "dashboard",
  components: {
    OfficeBacklog,
    OfficeShipped
    // ActiveBacklog2,
  },
  data: function() {
    return {
      details: false
    };
  },
  mounted() {
    allowedPath(
      router.currentRoute.path,
      localStorage.getItem("user_tabs"),
      localStorage.getItem("redirect_path")
    );
  }
  // methods: {
  //   switchView() {
  //     if(this.details == false) {
  //       this.details = true;
  //     } else {
  //       this.details = false;
  //     }
  //   },
  // }
};
</script>

<style>
/* IE fix */
#card-chart-01,
#card-chart-02 {
  width: 100% !important;
}
</style>
